import React, {useState} from 'react';
import {Container} from './Styled'
import FormWrapper from '../optionsMenu/ComponentMenu/FormWrapper/FormWrapper';
import BuilderContext from '../../../context/BuilderContext';
import { Flow } from '../../../../model/workflowEditor/flow/types';
type FloatFormProps = {
    flow: Flow
};

export const FloatForm: React.FunctionComponent<FloatFormProps> = ({ flow }) => {
    const [selectedElement, setSelectedElement] = useState<any>(undefined);
    const { builder } = React.useContext(BuilderContext);
    
    builder?.registerListener({
      id: 'selectionChanged', 
      callback: (event) => elementSelectionChanged(event)
    });
    
    const elementSelectionChanged = (event: any) => {
      event.isSelected ? setSelectedElement(event) : setSelectedElement(undefined);
    }
  
  return (
    selectedElement ?
   <Container>
       <FormWrapper flow={flow} node={selectedElement}/>
   </Container> : null
  );
}

export default FloatForm;